import { Check, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function SyncBoardIntro() {
  return (
    <section
      data-testid="syncboard-intro"
      className="max-w-[1600px] mx-auto px-6 md:px-10 py-20 md:py-24"
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        {/* ============ SCREENSHOT SIDE ============ */}
        <div className="relative order-1 lg:order-1">
          {/* Soft ambient glow behind image */}
          <div className="absolute -inset-4 bg-gold/10 blur-3xl rounded-3xl pointer-events-none" aria-hidden />
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-border bg-ink">
            <img
              src="/syncboard.jpeg"
              alt="SyncBoard workspace preview showing a branded asset board with photo and video approvals"
              data-testid="syncboard-image"
              className="block w-full h-auto"
            />

            {/* Teal accent — ring + pulse + checkmark badge over an asset card
                Positioned as % of the image so it scales with any container width. */}
            <div
              aria-hidden
              className="absolute pointer-events-none"
              style={{ left: "62.5%", top: "56%", width: "22%", height: "26%" }}
            >
              {/* teal ring hugging an approved card */}
              <div className="absolute inset-0 rounded-lg ring-2 ring-gold/90 shadow-[0_0_40px_rgba(13,148,136,0.55)]" />
              {/* pulse aura */}
              <div className="absolute inset-0 rounded-lg ring-4 ring-gold/40 animate-ping" style={{ animationDuration: "2.2s" }} />
            </div>
            {/* Checkmark badge sitting on the corner of the highlighted card */}
            <div
              aria-hidden
              className="absolute"
              style={{ left: "82%", top: "54%" }}
              data-testid="syncboard-approve-badge"
            >
              <div className="relative">
                <div className="absolute inset-0 rounded-full bg-gold/40 blur-md animate-pulse" style={{ animationDuration: "2s" }} />
                <div className="relative w-11 h-11 md:w-12 md:h-12 rounded-full bg-gold text-ivory flex items-center justify-center shadow-lg ring-4 ring-ivory/90">
                  <Check className="h-5 w-5 md:h-6 md:w-6" strokeWidth={3} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ============ TEXT SIDE ============ */}
        <div className="order-2 lg:order-2 lg:pl-6">
          <div className="text-[11px] uppercase tracking-[0.35em] text-gold mb-3">SyncBoard™ — Introducing</div>
          <h2
            data-testid="syncboard-headline"
            className="font-serif text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
          >
            Stop Chasing Approvals.<br />
            <span className="text-gold italic">Start Closing Campaigns.</span>
          </h2>
          <p
            data-testid="syncboard-subheadline"
            className="mt-6 md:mt-8 text-base md:text-lg text-muted-foreground leading-relaxed max-w-xl"
          >
            <span className="text-ink font-medium">One Link. One Board. Instant Approval.</span> EliteStock turns the chaos of agency-to-client feedback into a single, unified workspace.
          </p>
          <button
            type="button"
            data-testid="syncboard-cta"
            onClick={() => toast.success("SyncBoard walkthrough coming soon", { description: "We'll notify you when it goes live." })}
            className="group mt-8 md:mt-10 inline-flex items-center gap-3 px-6 md:px-7 py-3.5 bg-gold text-ivory hover:bg-gold/90 text-sm tracking-wide transition-colors"
          >
            See how SyncBoard works.
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
}
